import * as React from 'react'
import GroupsLIstNavbar from './GroupsLIstNavbar'
import GroupsListItem from './GroupsListItem'
import { faUserCheckSolid, faUserDashedRegular } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GroupsDefaultList = ({ isActive }: { isActive: boolean }) => {
  const { t } = useLocalize()
  const defatultGroups = [
    { id: -1, name: t('driverModule.active-drivers'), checked: isActive },
    { id: -2, name: t('driverModule.inactive-drivers'), checked: !isActive },
  ]
  return (
    <div>
      <GroupsLIstNavbar title={t('driverModule.default')} />
      <div className="tw-flex tw-flex-col">
        {defatultGroups.map((group) => {
          return (
            <GroupsListItem
              key={group.id}
              group={group}
              disabled={true}
              defaultChecked={group.checked}
              solidIcon={faUserCheckSolid}
              regularIcon={faUserDashedRegular}
            />
          )
        })}
      </div>
    </div>
  )
}

export default GroupsDefaultList
